import React from "react";
import "./Home.css";
import { Profile } from "../Profile";

export const NSFGrant = () => {
  const laura = {
    title: "Prof",
    firstName: "Laura",
    surname: "Barnes",
    university: "University of Virginia",
    bio: "https://engineering.virginia.edu/faculty/laura-barnes",
    image: "./images/profiles/LauraBarnes.webp",
    linkedin: "https://www.linkedin.com/in/lauraebarnes/",
    twitter: null,
    email: "lb3dp@virginia.edu",
  };

  return (
    <div className="page-layout">
      <div className="text-layout">
        <h2>
          NSF Student Travel Grant for IEEE SMARTCOMP 2025 (US-based Students
          ONLY)
        </h2>
        <p>
          The 11th IEEE Conference on Smart Computing (SMARTCOMP 2024), to be
          held in-person in Cork, Ireland from June 16 to June 19, 2025, is{" "}
          <span style={{ fontWeight: "bold" }}>
            expected to offer NSF-sponsored competitive student travel grants
          </span>{" "}
          to support attendance at{" "}
          <a href="https://www.cs.ucc.ie/smartcomp2025/">SMARTCOMP 2025</a> and
          co-located events such as Workshops, the Ph.D. Forum,
          Work-in-Progress, Posters, and Demo sessions.
        </p>
        <p>
          These travel grants are intended for{" "}
          <span style={{ fontWeight: "bold" }}>
            full-time students enrolled at colleges and universities in the
            United States.
          </span>{" "}
          We particularly encourage applications from underrepresented minority
          and women students from diverse US institutions. Both student authors
          and non-author students—including exceptional undergraduate, MS, and
          PhD students engaged in smart computing research—are eligible to
          apply. Acceptance of a paper is not required to be considered for the
          travel grant.
        </p>
        <p>
          Ph.D. students applying for the travel grant are{" "}
          <span style={{ fontWeight: "bold" }}>
            strongly encouraged to also apply to the Ph.D. Forum.
          </span>
        </p>
        <p>
          To be eligible, US-based students (referred to as “you”) must submit
          an application via the{" "}
          <a href="https://forms.gle/hSNB3jyqfDB8GmZx7">Google Form link</a> by{" "}
          <span style={{ fontWeight: "bold" }}>April 30th, 2025.</span>
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Application Requirements</span>{" "}
          To apply for NSF travel support, please upload the following
          documents:
        </p>
        <ol>
          <li>
            <span style={{ fontWeight: "bold" }}>One-page Cover Letter</span>{" "}
            that includes:
          </li>
          <ul>
            <li>
              Confirmation that you are a full-time student (B.S., M.S., or
              Ph.D.)
            </li>
            <li>
              A statement that you will attend the entire SMARTCOMP 2025
              conference and associated events
            </li>
            <li>
              A brief summary of your research interests and accomplishments in
              smart computing
            </li>
            <li>
              A description of how attending SMARTCOMP 2025 would benefit your
              research and academic goals
            </li>
            <li>
              How you plan to contribute to and benefit from the conference
              experience
            </li>
          </ul>
          <li>
            <span style={{ fontWeight: "bold" }}>Two-page CV</span>
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Letter of Recommendation</span>{" "}
            from your academic mentor confirming:
          </li>
          <ul>
            <li>Your full-time student status and good academic standing</li>
            <li>
              Your engagement in smart computing research and potential for
              contributions
            </li>
            <li>The benefits you would gain from attending the conference</li>
            <li>
              Your commitment to attend the entire conference and associated
              events
            </li>
          </ul>
        </ol>
        <p>
          <span style={{ fontWeight: "bold" }}>Reimbursable expenses</span>{" "}
          include the advance registration fee (for student authors and
          non-authors), airfare, and hotel accommodations. Expenses not eligible
          for reimbursement include regular/on-site registration, internet fees,
          etc. Reimbursements will be processed
          <span style={{ fontWeight: "bold" }}>after the conference</span>, upon
          submission of the required receipts. The reimbursement amount will
          depend on the total number of awardees and available funding.
        </p>
        <p>
          For questions regarding the travel award, please contact: Dr. Laura
          Barnes
        </p>
        <Profile props={laura} />
      </div>
    </div>
  );
};
